// @owners { team: patient-health }
import {
  type ActionSelectDate,
  type ActionSetTimezoneOffset,
  CREATE_REMINDER_SUCCEEDED,
  DELETE_REMINDER_SUCCEEDED,
  FETCH_REMINDERS_LOADING,
  FETCH_REMINDERS_SUCCEEDED,
  type ReminderAction,
  SELECT_DATE,
  SET_TIMEZONE_OFFSET,
  UPDATE_REMINDER_SUCCEEDED,
} from '~shared/actions/reminders';
import { immutableBulkUpsert, immutableUpsert } from '~shared/helpers/immutableUpsert';
import { type ReminderSequence } from '~shared/types';

export const initialState = {
  activeDay: new Date().getTime(),
  activeTimezoneOffset: new Date().getTimezoneOffset() / 60,
  reminders: [],
  lastRequestAttemptedAt: 0,
  requestAttemptCount: 0,
  lastRequestSucceededAt: 0,
};

export type StateReminders = {
  activeDay: number;
  reminders: ReminderSequence[];
  activeTimezoneOffset: number;
  lastRequestAttemptedAt: number;
  requestAttemptCount: number;
  lastRequestSucceededAt: number;
};

type DateAction = ActionSelectDate | ActionSetTimezoneOffset;

export default (state: StateReminders = initialState, action: ReminderAction | DateAction): StateReminders => {
  const { type } = action;

  switch (type) {
    case DELETE_REMINDER_SUCCEEDED: {
      const { payload } = action;

      return {
        ...state,
        reminders: immutableBulkUpsert({
          state: state.reminders,
          payload,
        }),
      };
    }

    case CREATE_REMINDER_SUCCEEDED: {
      const { payload } = action;

      return {
        ...state,
        reminders: immutableUpsert({
          state: state.reminders,
          payload,
        }),
      };
    }

    case FETCH_REMINDERS_LOADING: {
      return { ...state, lastRequestAttemptedAt: Date.now(), requestAttemptCount: state.requestAttemptCount + 1 };
    }

    case FETCH_REMINDERS_SUCCEEDED: {
      const { payload } = action;

      return { ...state, reminders: payload, lastRequestSucceededAt: Date.now(), requestAttemptCount: 0 };
    }

    case SELECT_DATE: {
      const { payload } = action;

      return { ...state, activeDay: payload.valueOf() };
    }

    case SET_TIMEZONE_OFFSET: {
      const { payload } = action;

      return { ...state, activeTimezoneOffset: payload };
    }

    // eslint-disable-next-line sonarjs/no-duplicated-branches
    case UPDATE_REMINDER_SUCCEEDED: {
      const { payload } = action;

      return {
        ...state,
        reminders: immutableUpsert({
          state: state.reminders,
          payload,
        }),
      };
    }

    default:
      return state;
  }
};
